/* Customers */
import {
  LOAD_DATA_FAILURE, RESET_STORE, SET_CUSTOMERS, SET_CUSTOMERS_REQUEST,
  SET_MESSAGES, SET_MESSAGES_REQUEST
} from "../actionTypes";
import CampaignsModelMC from "../presentation/models/CampaignsModelMC";
import { clearTenantLinesCache } from "../presentation/hooks/voice/infrastructure/voiceTenantLinesCache";
import { invalidateSipStatusCache } from "../presentation/hooks/voice/infrastructure/voiceSipStatusCache";
import { clearMicroserviceChatbotsCache } from "../services/chatbots/dualApiMergeChatbotService";
import { resetMsInboxCountersCache } from "../services/inbox/msInboxCountersClient";

export const fetchCustomers = (page = 1, params, offset, platform = 'messenger') => {
  let endpoint = `/api/v1/customers?page=${page}&offset=${offset}&platform=${platform}`;

  if (params !== null && params !== undefined) {
    endpoint += `&${$.param(params)}`;
  }

  return (dispatch) => {
    dispatch({ type: SET_CUSTOMERS_REQUEST });
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: SET_CUSTOMERS, data }),
        (err) => dispatch({ type: LOAD_DATA_FAILURE, err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const fetchCustomer = (id, service = '') => {
  const endpoint = `/api/v1/customers/${id}?service=${service}`;
  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: "SET_CUSTOMER", data }),
        (err) => dispatch({ type: "LOAD_DATA_FAILURE", err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const fetchNotes = (id, platform, customer_fb_post = 0) => {
  const endpoint = `/api/v1/customers/${id}/notes?platform=${platform}&customer_fb_post_id=${customer_fb_post}`;
  return (dispatch) => {
    dispatch({ type: 'SET_NOTES_START' });
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => {
          dispatch({ type: "SET_NOTES", data });
          dispatch({ type: 'SET_NOTES_END' });
        },
        (err) => {
          dispatch({ type: "LOAD_DATA_FAILURE", err });
          dispatch({ type: 'SET_NOTES_END' });
        }
      ).catch(
        (err) => {
          dispatch({ type: "LOAD_DATA_FAILURE", err });
          dispatch({ type: 'SET_NOTES_END' });
        }
      );
  };
};

export const addNote = (body) => (
  (dispatch) => (
    dispatch({ type: "ADD_NOTE", body })
  )
);

export const updateCustomer = (id, body, token) => {
  const endpoint = `/api/v1/customers/${id}`;
  const csrfToken = token;
  return (dispatch) => {
    fetch(endpoint, {
      method: "PUT",
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/plain, */*'
      },
      body: JSON.stringify(body)
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: 'SET_CUSTOMER', data }),
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const cancelReminder = (reminderId) => {
  const endpoint = `/api/v1/reminders/${reminderId}/cancel`;
  return (dispatch) => {
    fetch(endpoint, {
      method: "PUT",
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/plain, */*'
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: 'SET_CUSTOMER', data }),
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

/* Messages */

export const fetchMessages = (id, page = 1, platform = 'messenger') => {
  const endpoint = `/api/v1/customers/${id}/messages?page=${page}&platform=${platform}`;
  return (dispatch) => {
    dispatch({ type: SET_MESSAGES_REQUEST });
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: SET_MESSAGES, data }),
        (err) => dispatch({ type: LOAD_DATA_FAILURE, err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const sendMessage = (id, body, token, platform = 'messenger') => {
  const endpoint = `/api/v1/customers/${id}/messages?platform=${platform}`;
  const csrfToken = token;
  return (dispatch) => {
    fetch(endpoint, {
      method: "POST",
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/plain, */*'
      },
      body: JSON.stringify(body)
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: 'SET_SEND_MESSAGE', data }),
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const sendImg = (id, body, token, platform = 'messenger') => {
  const endpoint = `/api/v1/customers/${id}/messages/imgs?platform=${platform}`;
  const csrfToken = token;
  return (dispatch) => {
    fetch(endpoint, {
      method: "POST",
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': csrfToken
      },
      body
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: 'SET_SEND_MESSAGE', data }),
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const setMessageAsRead = (id, token, platform = 'messenger') => {
  const endpoint = `/api/v1/messages/${id}/read?platform=${platform}`;
  const csrfToken = token;
  return (dispatch) => {
    fetch(endpoint, {
      method: "POST",
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/plain, */*'
      },
      body: ''
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: 'SET_SEND_MESSAGE', data }),
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const getMessengerFastAnswers = (params) => {
  const encodedParams = new URLSearchParams(params).toString();
  const endpoint = `/api/v1/fast_answers_for_messenger?${encodedParams}`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: "SET_MESSENGER_FAST_ANSWERS", data }),
        (err) => dispatch({ type: "LOAD_DATA_FAILURE", err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const getInstagramFastAnswers = (params = {}) => {
  const encodedParams = new URLSearchParams(params).toString();
  const endpoint = `/api/v1/fast_answers_for_instagram?${encodedParams}`;

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: "SET_INSTAGRAM_FAST_ANSWERS", data }),
        (err) => dispatch({ type: "LOAD_DATA_FAILURE", err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const getProducts = (page = 1, params) => {
  let endpoint = `/api/v1/products?page=${page}`;

  if (params !== '' && params !== undefined) {
    endpoint += `&search=${params}`;
  }

  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: "SET_PRODUCTS", data }),
        (err) => dispatch({ type: "LOAD_DATA_FAILURE", err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const sendBulkFiles = (id, body, token, platform = 'messenger') => {
  const endpoint = `/api/v1/customers/${id}/messages/send_bulk_files?platform=${platform}`;
  const csrfToken = token;
  return (dispatch) => {
    fetch(endpoint, {
      method: "POST",
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': csrfToken
      },
      body
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: 'SET_SEND_MESSAGE', data }),
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

/* Custom Fields */
export const fetchCustomerFields = (customerId) => {
  const endpoint = `/api/v1/customers/${customerId}/custom_fields`;
  return (dispatch) => {
    dispatch({ type: 'SET_CUSTOM_FIELDS_START' });
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => {
          dispatch({ type: "SET_CUSTOM_FIELDS", data });
          dispatch({ type: 'SET_CUSTOM_FIELDS_END' });
        },
        (err) => {
          dispatch({ type: "LOAD_DATA_FAILURE", err });
          dispatch({ type: 'SET_CUSTOM_FIELDS_END' });
        }
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
        dispatch({ type: 'SET_CUSTOM_FIELDS_END' });
      });
  };
};

/* Custom Fields */
export const fetchCustomFields = () => {
  const endpoint = `/api/v1/customers/custom_fields`;
  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => {
          dispatch({ type: "CONFIG_CUSTOM_FIELDS", data });
        },
        (err) => {
          dispatch({ type: "LOAD_DATA_FAILURE", err });
        }
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const updateCustomerField = (customerId, id, body, token) => {
  const endpoint = `/api/v1/customers/${customerId}/custom_fields/${id}`;
  const csrfToken = token;
  return (dispatch) => {
    fetch(endpoint, {
      method: "PUT",
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/plain, */*'
      },
      body: JSON.stringify(body)
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: 'SET_CUSTOM_FIELDS', data }),
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const changeChatMessagingState = (body, token) => {
  const endpoint = '/api/v1/change_chat_status';
  const csrfToken = token;

  return (dispatch) => {
    fetch(endpoint, {
      method: "PUT",
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/plain, */*'
      },
      body: JSON.stringify(body)
    })
      .then((res) => res.json())
      .then(
        (data) => {
          dispatch({ type: 'CHANGE_CHAT_STATUS', data });
        },
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        if (error.response) alert(error.response);
        else alert("An unexpected error occurred.");
      });
  };
};

export const fetchCurrentRetailerUser = (forceReload = false) => {
  const endpoint = `/api/v1/retailer_users/current_retailer_user`;
  return (dispatch, getState) => {
    const { currentRetailerUser } = getState().mainReducer;
    if (forceReload || !currentRetailerUser || !currentRetailerUser.id) {
      fetch(endpoint, {
        method: "GET",
        credentials: "same-origin",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json"
        }
      })
        .then((res) => res.json())
        .then(
          (data) => dispatch({ type: "SET_CURRENT_RETAILER_USER", data }),
          (err) => dispatch({ type: "LOAD_DATA_FAILURE", err })
        ).catch((error) => {
          if (error.response) {
            alert(error.response);
          } else {
            alert("An unexpected error occurred.");
          }
        });
    }
  };
};

export const sendFacebookMultipleAnswers = (id, body, token, platform = 'messenger') => {
  const endpoint = `/api/v1/customers/${id}/messages/send_multiple_answers?platform=${platform}`;
  const csrfToken = token;
  return (dispatch) => {
    fetch(endpoint, {
      method: "POST",
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': csrfToken
      },
      body
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: 'SET_SEND_MESSAGE', data }),
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

export const fetchReminders = (id) => {
  const endpoint = `/api/v1/reminders/customers/${id}/list`;
  return (dispatch) => {
    dispatch({ type: 'SET_REMINDERS_START' });
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => {
          dispatch({ type: "SET_REMINDERS", data });
          dispatch({ type: 'SET_REMINDERS_END' });
        },
        (err) => {
          dispatch({ type: "LOAD_DATA_FAILURE", err });
          dispatch({ type: 'SET_REMINDERS_END' });
        }
      ).catch(
        (err) => {
          dispatch({ type: "LOAD_DATA_FAILURE", err });
          dispatch({ type: 'SET_REMINDERS_END' });
        }
      );
  };
};

export const fetchCampaigns = (params = {}) => {
  return async (dispatch) => {
    dispatch({ type: "START_CAMPAIGNS_REQUEST" });
    
    try {
      const data = await CampaignsModelMC.getCampaigns(params);
      dispatch({ type: "END_CAMPAIGNS_REQUEST" });
      dispatch({ type: "SET_CAMPAIGNS", data });
    } catch (err) {
      dispatch({ type: "END_CAMPAIGNS_REQUEST" });
      dispatch({ type: "SET_CAMPAIGNS_ERROR", err });
    }
  };
};

export const fetchRetailerOnboardings = (retailerId) => {
  const endpoint = `/api/v1/retailer_onboardings?retailer_id=${retailerId}`;
  return (dispatch) => {
    fetch(endpoint, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      }
    })
      .then((res) => res.json())
      .then(
        (data) => {
          dispatch({ type: "SET_RETAILER_ONBOARDING", data });
        },
        (err) => {
          dispatch({ type: "LOAD_DATA_FAILURE", err });
        }
      ).catch((err) => {
        dispatch({ type: "LOAD_DATA_FAILURE", err });
      });
  };
};

export const updateRetailerOnboarding = (id, body, token) => {
  const endpoint = `/api/v1/retailer_onboardings/${id}`;
  const csrfToken = token;
  return (dispatch) => {
    fetch(endpoint, {
      method: "PUT",
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json, text/plain, */*'
      },
      body: JSON.stringify(body)
    })
      .then((res) => res.json())
      .then(
        (data) => dispatch({ type: 'SET_RETAILER_ONBOARDING', data }),
        (err) => dispatch({ type: 'LOAD_DATA_FAILURE', err })
      ).catch((error) => {
        if (error.response) {
          alert(error.response);
        } else {
          alert("An unexpected error occurred.");
        }
      });
  };
};

/**
 * Action to reset the Redux store state.
 *
 * @function resetStore
 * @returns {Object} The action with type `RESET_STORE`.
 *
 * @example
 * // Dispatch the action to reset the store state
 * dispatch(resetStore());
 */
export const resetStore = () => {
  clearMicroserviceChatbotsCache();
  // Caches module-level de voz: no viven en Redux, hay que limpiarlos en cambio de sesión.
  clearTenantLinesCache();
  invalidateSipStatusCache();
  resetMsInboxCountersCache();
  return {
    type: RESET_STORE
  };
};
